// FILE: src/pages/InviteLanding.js
// Redirects /invite/:id[?token=...] → /accept-invitation?id=...&token=...
import { useEffect } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

export default function InviteLanding() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [query] = useSearchParams();

  useEffect(() => {
    const token = query.get("token");
    const search = new URLSearchParams();
    if (id) search.set("id", id);
    if (token) search.set("token", token);
    navigate(`/accept-invitation?${search.toString()}`, { replace: true });
  }, [id, query, navigate]);

  return null;
}
